import { createSlice } from '@reduxjs/toolkit';

const UpdateUserNotificationSlice = createSlice({
  name: 'UpdateUserNotificationsService',
  initialState: {
    loading: false,
    data: null,
    error: null,
    success: false
  },
  reducers: {
    UpdateUserNotificationsServiceInit(state) {
      state.loading = true;
      state.error = null;
    },
    UpdateUserNotificationsServiceSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.success = true;
    },
    UpdateUserNotificationsServiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    UpdateUserNotificationsServiceReset(state) {
      return { ...state, loading: false, data: null, success: false, error: null };
    },
  },
});

export const {
  UpdateUserNotificationsServiceInit,
  UpdateUserNotificationsServiceSuccess,
  UpdateUserNotificationsServiceFailure,
  UpdateUserNotificationsServiceReset
} = UpdateUserNotificationSlice.actions;

export default UpdateUserNotificationSlice.reducer;
